<template>
  <div id="app">

    <!--<keep-alive include="menus">-->
      <router-view/>
    <!--</keep-alive>-->
  </div>
</template>

<script>
import router from "./router";

export default {
  name: 'App',
  data() {
    return {

    }
  },
  created(){
    // console.log(this)
    // console.log(this._uid)
    // if (this._isMobile()) {
    //   console.log(111)
    //   //手机端
    //   this.$router.replace({name:'appindex'})
    // }else{
    //   this.$router.replace({name:'index'})
    // }

    console.log(router)

  },
  mounted() {
    let isMobile=this._isMobile()
    let size=0
    if(isMobile){
      let $html=document.documentElement,
        windowW = window.innerWidth,
        ratio = windowW / 750
      if (windowW > 750) {
        $html.style.fontSize='100px'
      } else {
        $html.style.fontSize = 100 * ratio + "px"
      }
    }else{
      var whdef = 14/1920;// 表示1180的设计图,使用100PX的默认值
      var wH = window.innerHeight;// 当前窗口的高度
      var wW = window.innerWidth;// 当前窗口的宽度
      var rem = wW * whdef;// 以默认比例值乘以当前窗口宽度,得到该宽度下的相应FONT-SIZE值
      document.documentElement.style.fontSize=rem + "px"
      window.onresize = function(){
        var whdef = 14/1920;// 表示1180的设计图,使用100PX的默认值
        var wH = window.innerHeight;// 当前窗口的高度
        var wW = window.innerWidth;// 当前窗口的宽度
        var rem = wW * whdef;// 以默认比例值乘以当前窗口宽度,得到该宽度下的相应FONT-SIZE值
        document.documentElement.style.fontSize=rem + "px"
      }
    }


  },
  methods: {
    //判断
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    }
  }
}
</script>

<style>
  .pagebg{
    background: url("./assets/images/pagebg.jpeg") #f7f3f0 no-repeat center bottom;
    background-size:100% 100%;
    width:100%;
    position: fixed;
    top:8.5rem;
    bottom:7rem;
    overflow-y: auto;
  }
  .pagemode{
    position: fixed;
    top:0;
    bottom:0;
    left:0;
    right:0;
    background: rgba(0,0,0,0.2);
  }
</style>



// WEBPACK FOOTER //
// src/App.vue